import { CREATE_RATING, CREATE_RATING_SUCCESS, GET_ALL_BADGES, GET_ALL_BADGES_SUCCESS, GET_GAMIFICATION_CRITERIA, GET_GAMIFICATION_CRITERIA_SUCCESS, GET_GAMIFICATION_CRITERIA_USER, GET_GAMIFICATION_CRITERIA_USER_SUCCESS, GET_MY_RATING, GET_MY_RATING_SUCCESS, GET_RATING_BY_ID, GET_RATING_BY_ID_SUCCESS, GET_REPORT_HISTORY, GET_REPORT_HISTORY_BY_ID, GET_REPORT_HISTORY_BY_ID_SUCCESS, GET_REPORT_HISTORY_SUCCESS, GET_UNLOCKED_BADGE, GET_UNLOCKED_BADGE_SUCCESS, GET_WORKER_PERFORMANCE, GET_WORKER_PERFORMANCE_SUCCESS } from "../storeTypes"
const initialState: any = {
    rating: undefined,
    MyRating: [{
        data: [],
        count: ''
    }],
    loader: false,
    reportHistory: null,
    reportHistoryById: null,
    gamificationCriteria: null,
    earnedBadges: null,
    allBadges: null,
    unlockedBadges: null,
    workerPerformance: null
}
const RatingReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_RATING_BY_ID:
            return {
                ...state,
                loader: true,
            }
        case GET_RATING_BY_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                rating: action.payload
            }
        case CREATE_RATING:
            return {
                ...state,
                loader: true
            }
        case CREATE_RATING_SUCCESS:
            return {
                ...state,
                loader: false
            }
        case GET_MY_RATING:
            return {
                ...state,
                loader: true
            }
        case GET_MY_RATING_SUCCESS:
            return {
                ...state,
                loader: false,
                MyRating: action.payload
            }
        case GET_REPORT_HISTORY:
            return {
                ...state,
                loader: true,
                reportHistory: null
            }
        case GET_REPORT_HISTORY_SUCCESS:
            return {
                ...state,
                loader: false,
                reportHistory: action.payload
            }
        case GET_REPORT_HISTORY_BY_ID:
            return {
                ...state,
                loader: true
            }
        case GET_REPORT_HISTORY_BY_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                reportHistoryById: action.payload
            }
        case GET_GAMIFICATION_CRITERIA:
            return {
                ...state,
                loader: true
            }
        case GET_GAMIFICATION_CRITERIA_SUCCESS:
            return {
                ...state,
                loader: false,
                gamificationCriteria: action.payload
            }
        case GET_ALL_BADGES:
            return {
                ...state,
                loader: true
            }
        case GET_ALL_BADGES_SUCCESS:
            return {
                ...state,
                loader: false,
                allBadges: action.payload
            }
        case GET_GAMIFICATION_CRITERIA_USER:
            return {
                ...state,
                loader: true
            }
        case GET_GAMIFICATION_CRITERIA_USER_SUCCESS:
            return {
                ...state,
                loader: false,
                earnedBadges: action.payload
            }
        case GET_UNLOCKED_BADGE:
            return {
                ...state,
                loader: true
            }
        case GET_UNLOCKED_BADGE_SUCCESS:
            return {
                ...state,
                loader: false,
                unlockedBadges: action.payload
            }
        case GET_WORKER_PERFORMANCE:
            return {
                ...state,
                loader: true,
                workerPerformance: null
            }
        case GET_WORKER_PERFORMANCE_SUCCESS:
            return {
                ...state,
                loader: false,
                workerPerformance: action.payload.data
            }
        default:
            return state;
    }
}

export default RatingReducer
